import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=5bb49a5e&scoped=true&"
import script from "./EmailSettings.vue?vue&type=script&lang=js&"
export * from "./EmailSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettings.vue?vue&type=style&index=0&id=5bb49a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb49a5e",
  null
  
)

export default component.exports